import React, { useState, useEffect, useContext, useCallback } from "react";
import { FaHandsClapping } from "react-icons/fa6";
import { AuthContext } from "../context/AuthContext";
import { post, get } from "aws-amplify/api";

export default function ClapsButton({ articleId, className = "" }) {
  const { user } = useContext(AuthContext);
  const [clapsCount, setClapsCount] = useState(0);
  const [userClaps, setUserClaps] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  
  const fetchClapsData = useCallback(async () => {
    if (!articleId) return;
    
    setIsLoading(true);
    try {
      // Get total claps for the article
      const totalResponse = await get({
        apiName: 'recommendationApi',
        path: `/interactions/claps/${articleId}`
      });
      
      setClapsCount(totalResponse.body.count || 0);
      
      // If user is logged in, get their claps for this article
      if (user) {
        const userResponse = await get({
          apiName: 'recommendationApi',
          path: `/interactions/claps/${articleId}/user`
        });
        
        setUserClaps(userResponse.body.count || 0);
      }
    } catch (error) {
      console.error("Error fetching claps data:", error);
    } finally {
      setIsLoading(false);
    }
  }, [articleId, user]);
  
  useEffect(() => {
    fetchClapsData();
  }, [fetchClapsData]);
  

  
  const handleClap = async () => {
    if (!user) {
      alert("Please sign in to clap for this article");
      return;
    }
    
    if (userClaps >= 50) {
      alert("You've reached the maximum number of claps for this article");
      return;
    }
    
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 500);
    
    try {
      await post({
        apiName: 'recommendationApi',
        path: '/interactions',
        options: {
          body: {
            articleId,
            interactionType: 'clap',
            count: 1
          }
        }
      });
      
      // Update local state
      setClapsCount(prevCount => prevCount + 1);
      setUserClaps(prevCount => prevCount + 1);
      
      // Track this interaction for recommendations
      if (window.RecommendationService && window.RecommendationService.trackInteraction) {
        window.RecommendationService.trackInteraction(
          user.username, 
          articleId, 
          'clap'
        );
      }
    } catch (error) {
      console.error("Error adding clap:", error);
    }
  };
  
  return (
    <div className={`flex items-center ${className}`}>
      <button
        onClick={handleClap}
        disabled={isLoading || !user || userClaps >= 50}
        className={`flex items-center space-x-1 px-3 py-1 rounded-full 
          ${userClaps > 0 ? 'bg-taupe/10 text-taupe-dark' : 'bg-gray-100 text-gray-700'} 
          hover:bg-taupe/20 transition-all ${isAnimating ? 'scale-110' : 'scale-100'}`}
      >
        <FaHandsClapping className={`${userClaps > 0 ? 'text-taupe-dark' : 'text-gray-500'}`} />
        <span>{clapsCount}</span>
      </button>
      
      {user && userClaps > 0 && (
        <span className="text-xs text-gray-500 ml-2">
          You clapped {userClaps} {userClaps === 1 ? 'time' : 'times'}
        </span>
      )}
    </div>
  );
}